/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { toast } from "react-toastify";
import styled from "styled-components";

import { ShareInput } from "src/components/Plate/ShareMenu/lib/styles";
import { Button } from "src/components/UI/Buttons/ButtonPrimitives";
import { TOAST_DEFAULT_ARGS } from "src/lib/constants";

interface Props {
  link: string;
  copyLink: () => void;
}

export function SharablePageLink({ link, copyLink }: Props) {
  const handleCopy = () => {
    copyLink();
    toast.success("Link Copied", TOAST_DEFAULT_ARGS);
  };

  return (
    <ShareActions>
      <ShareInput onChange={() => {}} value={link} style={{ marginRight: "10px" }} />
      <Button onClick={handleCopy}>copy</Button>
    </ShareActions>
  );
}

const ShareActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  font-weight: 400;
  font-size: 12px;
`;
